import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { captureAttribution, takePendingLanding } from './attribution'
import { trackCampaignLinkOpened } from './trackingFunctions'

/**
 * Mounted once beside the router. Sends the landing event for the visit captured at import time,
 * then watches every navigation for a newly tagged link. The login redirect replaying the landing
 * query is recognised as the same visit and not sent again.
 */
export function AttributionCapture() {
  const location = useLocation()
  useEffect(() => {
    const envelope = takePendingLanding() ?? captureAttribution(window.location)
    if (envelope) trackCampaignLinkOpened(envelope)
  }, [location])
  return null
}
